/**
 * User Profile Hooks
 * მომხმარებლის პროფილის hooks
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getCurrentUser,
  updateProfile,
  getProfileStatus,
  deleteAccount,
  type User,
  type UpdateProfileRequest,
  type ProfileStatus,
} from '../features/api/user';

const QUERY_KEYS = {
  user: ['user', 'current'] as const,
  profileStatus: ['user', 'profile-status'] as const,
};

export function useCurrentUser() {
  const { data, isLoading, error, refetch } = useQuery<User>({
    queryKey: QUERY_KEYS.user,
    queryFn: getCurrentUser,
  });

  return {
    user: data,
    isLoading,
    error,
    refetch,
  };
}

export function useProfileStatus() {
  const { data, isLoading, error, refetch } = useQuery<ProfileStatus>({
    queryKey: QUERY_KEYS.profileStatus,
    queryFn: getProfileStatus,
  });

  return {
    profileStatus: data,
    isLoading,
    error,
    refetch,
  };
}

export function useDeleteAccount() {
  return useMutation({
    mutationFn: () => deleteAccount(),
  });
}

export function useUpdateProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateProfileRequest) => updateProfile(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.user });
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.profileStatus });
    },
  });
}
